import { RoleFormValues } from '@/types';
import {
  SetDataByKeyValuePair,
  SetDataByMethod,
  SetDataByObject,
} from '@/core/const';

export const SUPER_ADMIN_ROLE = 'super_admin';

export const SYSTEM_ADMIN_ROLE_TYPE = 'system_admin';

export type SetIntertiaRoleFormData = SetDataByObject<RoleFormValues> &
  SetDataByMethod<RoleFormValues> &
  SetDataByKeyValuePair<RoleFormValues>;
